export default __webpack_public_path__ + "/dist/images/968140.png";